import React, { Component, Fragment } from "react";
import ReactToPrint from "react-to-print";
import "./americanfullreport.css";
import axios from "axios";
import USPrice from './common/PricesUS.json';
import USAAPrice from './common/PricesUSAA.json'
import LibertyMutualPrice from "./common/PricesLibertyMutualUS.json"
import ProgressivePrice from "./common/PricesProgressiveUS.json"
import NationalWidePrice from './common/PricesNationalWideUS.json'
import TravelersPrice from "./common/PricesTravelersUS.json"
import FarmersPrice from './common/PricesFarmersUS.json'
import { configuration } from "../appConfig";
import { Card, CardHeader } from "reactstrap";
import moment from "moment";
import AmericanReportAuthorization from "./common/AmericanReportAuthorization";

const [glue_percentage, replace_percentage] = [25.0, 25.0];

function findWithAttr(array, attr, value) {
  if(array && array.length) {
    for(var i = 0; i < array.length; i += 1) {
      if(array[i][attr] === value) {
        return i;
      }
    }
  }
  return -1;
}

const extraParts = [
  "Trunk",
  "LeftFrontTyre",
  "LeftBackTyre",
  "RightFrontTyre",
  "RightBackTyre",
  "FrontBumper",
  "BackBumper",
  "Underbody",
  "Inside",
];

export class AmericanReportFull extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: {},
      Dents: [],
      lang: "",
      scannerLocation: "",
      customerCompany: "",
      color: "",
      claimNo: "",
      regNo: "",
      manufacturer: "",
      estimateId: "",
      CarTypeArr: ["Van", "SUV", "Extended Cab Truck"],
      ALUPercentage: "",
      words: {},
      PricePerHour: 0,
      logo_image: "",
      address: "",
      email: "",
      primaryContact: "",
      company_name: "",
      qrEmail: "",
      orderNo: ""
    }
  }

  componentDidMount = () => {
    this.getData();
    this.getLang();
    this.getFallbackDetails()
  }

  getData = () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    let url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data) {
          this.setState({
            data: res.data,
            Dents: res.data.Dents || [],
            manufacturer: res.data.Make || '',
            regNo: res.data.RegNo || '',
            model: res.data.Model || '',
            color: res.data.Color || '',
            Name: `${res.data.CustomerVorname || ""} ${res.data.CustomerName || ""}` || '',
            comment: res.data.Comments || '',
            estimateId: res.data.OrderNo || '',
            scannerLocation: res.data.ScannerLocation || "",
            customerCompany: res.data.CustomerCompany || "",
            claimNo: res.data.ClaimNo || "",
            kilometerStand: res.data.KilometerReading | "",
            InsurenceName: res.data.InsurenceName || "",
            ShowPrice: res.data.ShowPrice || "",
            PricePerHour: !this.state.PricePerHour ? (res.data.PricePerHour ? parseInt(res.data.PricePerHour) : 0) : this.state.PricePerHour,
            orderNo: res.data.OrderNo || ''
          },() => res && res.data && res.data.Dents && this.mergeTrunkAndTrunkCover(res.data.Dents));
        }
      })
      .then( async () => {
        if(partnerId) {
          const res = await axios.get(
            configuration.getSingleQRDetails +
            "?partnerId=" +
            partnerId +
            "&vin=" +
            vin + "&qr_type=" + 1
          );
          if (res.data.data.length) {
            this.setState({
              estimateId: (!this.state.estimateId ? ( res.data.data[0].estimateId || '') : this.state.estimateId),
              manufacturer: (!this.state.manufacturer ? ( res.data.data[0].make || '') : this.state.manufacturer),
              regNo: (!this.state.regNo ? ( res.data.data[0].reg || '') : this.state.regNo),
              model: (!this.state.model ? ( res.data.data[0].model || '') : this.state.model),
              color: (!this.state.color ? ( res.data.data[0].color || '') : this.state.color),
              // Name: (!this.state.customerName ? ( res.data.data[0].customerName || '') : this.state.customerName),
              comment: (!this.state.comment ? ( res.data.data[0].comment || '') : this.state.comment),
              actualVIN: (!this.state.actualVIN ? ( res.data.data[0].vin || '') : this.state.actualVIN),
              InsurenceName: (!this.state.InsurenceName ? (  res.data.data[0].InsurenceName || '') : this.state.InsurenceName),
              customerCompany: (!this.state.customerCompany ? ( res.data.data[0].customerCompany || '-') : this.state.customerCompany),
              claimNumber: (!this.state.claimNumber ? ( res.data.data[0].claimNumber || '') : this.state.claimNumber),
              client: (!this.state.client ? ( res.data.data[0].client || '') : this.state.client),
              kilometerStand: (!this.state.kilometerStand ? ( res.data.data[0].kilometerStand || '-') : this.state.kilometerStand),
              qrEmail : res.data.data[0].email || '-'
            });
          }
        }
      })
      .then( async ()=>{
        if (partnerId) {
          const res = await axios.get(
            configuration.getCustomerInfo +
            "?partnerId=" +
            partnerId +
            "&vin=" +
            vin.split("_")[0]
          );
          if (res.data.length) {
            this.setState({
              kilometerStand: (!this.state.kilometerStand ? ( res.data[0].kilometerStand || '-') : this.state.kilometerStand),
              estimateId: (!this.state.estimateId ? ( res.data[0].orderid || '') : this.state.estimateId),
              manufacturer: (!this.state.manufacturer ? ( res.data[0].manufacturer || '-') : this.state.manufacturer),
              regNo: (!this.state.regNo ? ( res.data[0].regNo || '-') : this.state.regNo),
              model: (!this.state.model ? ( res.data[0].model || '-') : this.state.model),
              color: (!this.state.color ? ( res.data[0].color || '-') : this.state.color),
              // Name: (!this.state.Name ? ( res.data[0].Name || '-') : this.state.Name),
              comment: (!this.state.comment ? ( res.data[0].comment || '-') : this.state.comment),
            });
            localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
          }
        }
      })
      .catch((err) => {
      });
  }

  mergeTrunkAndTrunkCover = (dents) => {
    let trunkRow = dents[findWithAttr(dents, 'Part', 'Trunk')]
    dents.map((row) => {
      if(row.Part === 'TrunkCover') {
        row.A = (row.A ? row.A : 0) + (trunkRow.A  ? trunkRow.A  : 0)
        row.B = (row.B ? row.B : 0) + (trunkRow.B ? trunkRow.B : 0)
        row.C = (row.C ? row.C : 0) + (trunkRow.C ? trunkRow.C : 0)
        row.D = (row.D ? row.D : 0) + (trunkRow.D  ? trunkRow.D  : 0)
        row.E = (row.E ? row.E : 0) + (trunkRow.E ? trunkRow.E : 0)
        row.TotalDents = row.A + row.B + row.C + row.D + row.E;
        trunkRow.A = 0
        trunkRow.B = 0
        trunkRow.C = 0
        trunkRow.D = 0
        trunkRow.E = 0
        trunkRow.TotalDents = 0
      }
    })
    this.setState({
      Dents : dents
    })
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getFallbackDetails = async () => {
    let partnerId = localStorage.getItem("partnerId");
    const url = configuration.getFallbackDetails + `?partner_id=${partnerId}`;
    const res = await axios.get(url);
    if (res.data.success !== false) {
      this.setState({
        ALUPercentage: res.data.alu,
        LAKPercentage: res.data.lak,
        PricePerHour: res.data.PricePerHour || 40,
        logo_image: res.data.company_logo_base64 || require("../assets/img/brand/Adi.png"),
        address: res.data.company_address || "",
        email: res.data.company_email || "sales@adi-gmbh.com",
        primaryContact: res.data.contact_number || "08954809487",
        company_name: res.data.company_name || ''
      });
    }
  };

  getDescription = (row) => {
    const {client } = this.state;
    let OverValueWord = (client == "Libertymutual" || client == "Progressive") ? "MCE" : "CR"
    let maximumTotalDents = 250;
    if (["Libertymutual","Progressive","Travelers"].includes(client)) {
      maximumTotalDents = 400;
    } else if (["USAA","Farmers","Nationwide"].includes(client)) {
      maximumTotalDents = 300;
    } else {
      maximumTotalDents = 250;
    }
    let allSeverityClass= this.getSeverityClass(row,true)
    let [aluLakAddedPrice, originalPrice,desc,severityClass] = [this.getAluGlueAddedPrice(row),this.getOriginalPrice(row),"",this.getSeverityClass(row,true)];
    let totalDents = (row.A || 0)+ (row.B || 0) + (row.C || 0) + (row.D || 0) + (row.E || 0);
    if(totalDents > maximumTotalDents) {
      let obj = this.setTotalDent(row,severityClass.maxValueKey);
      // desc = `DENT COUNT: EXCEEDED MATRIX (${totalDents}). DIME: ${row.A || 0} NICKEL: ${row.B || 0} QUARTER: ${row.C || 0} HALF DOLLAR: ${row.D || 0} OS: ${row.E || 0}`
      desc = `DENT COUNT: EXCEEDED ${allSeverityClass.range || 0}. (DIME: ${row.A || 0} NICKEL: ${row.B || 0} QUARTER: ${row.C || 0} HALF DOLLAR: ${row.D || 0}`
    } else {
      if(originalPrice === OverValueWord || aluLakAddedPrice === OverValueWord) {
        let obj = this.setTotalDent(row,severityClass.maxValueKey);
        // desc = `DENT COUNT: EXCEEDED MATRIX (${totalDents}). DIME: ${row.A || 0} NICKEL: ${row.B || 0} QUARTER: ${row.C || 0} HALF DOLLAR: ${row.D || 0} OS: ${row.E || 0}`
        desc = `DENT COUNT: EXCEEDED ${allSeverityClass.range || 0}. (DIME: ${row.A || 0} NICKEL: ${row.B || 0} QUARTER: ${row.C || 0} HALF DOLLAR: ${row.D || 0}`
      } else {
        desc = `DENT COUNT: ${allSeverityClass.range || 0} SIZE: ${allSeverityClass.type || '-'}`
      }
    }

    return desc;
  }

  setTotalDent = (row, maxValueKey) => {
    let obj =  {
      "A" : 0,
      "B" : 0,
      "C" : 0,
      "D" : 0
    }
    obj[maxValueKey] = ((row.A || 0) + (row.B || 0) + (row.C || 0) + (row.D || 0))
    return obj;
  }

  getSeverityClass = (row, removeE) => {
    const {client} = this.state;
    const { A, B, C, D, E } = row;
    let parts = ["Hood", "Roof", "Trunk"];
    let [max, maxValueKey, range,totalDents] = ["", "", "",(row.A + row.B + row.C + row.D + row.E)];
    var obj = { A, B, C, D, E };
    var typeObj = {
      // A: "DIME",
      // B: "NICKEL",
      // C: "QUARTER",
      // D: "HALF DOLLAR",
      // E: "XL",
      A: "DIME",
      B: "NKL",
      C: "QTR",
      D: "HALF",
      E: "OS",
    };
    if (removeE) {
      delete obj.E;
      delete typeObj.E;
    }
    const severityOrder = ["A", "B", "C", "D", "E"];

    for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      if (value > max || (value === max && severityOrder.indexOf(key) > severityOrder.indexOf(maxValueKey))) {
        max = value;
        maxValueKey = key;
      }
    }
  }

    if(['A','B','C'].includes(maxValueKey) && !!D && !!E) {
      if( ((D || 0) + (E || 0)) > max){
        maxValueKey = 'D';
      }
    }

    // if (totalDents >= 1 && totalDents <= 5) {
    //   range = "VERY LIGHT (1 TO 5)";
    // } else if (totalDents >= 6 && totalDents <= 15) {
    //   range = "LIGHT (6 TO 15)";
    // } else if (totalDents >= 16 && totalDents <= 30) {
    //   range = "MODERATE (16 TO 30)";
    // } else if (parts.includes(row.Part) ? totalDents >= 31 && totalDents <= 50 : totalDents >= 31) {
    //   range = "MEDIUM (31 TO 50)";
    // } else if (parts.includes(row.Part) && totalDents >= 51 && totalDents <= 75) {
    //   range = "HEAVY (51 TO 75)";
    // } else if (parts.includes(row.Part) && totalDents >= 76 && totalDents <= 100) {
    //   range = "SEVERE (76 TO 100)";
    // } else if (parts.includes(row.Part) && totalDents >= 101 && totalDents <= 150) {
    //   range = "EXTREME (101 TO 150)";
    // } else if (parts.includes(row.Part) && totalDents >= 151 && totalDents <= 200) {
    //   range = "LIMIT (151 TO 200)";
    // } else if (parts.includes(row.Part) && totalDents >= 201) {
    //   range = "CEILING (201 TO 250)";
    // }
    if (client == "Libertymutual" || client == "Progressive" || client == "Travelers") {
      if (totalDents >= 1 && totalDents <= 5) {
      range = "VERY LIGHT (1 TO 5)";
    } else if (totalDents >= 6 && totalDents <= 15) {
      range = "LIGHT (6 TO 15)";
    } else if (totalDents >= 16 && totalDents <= 30) {
      range = "MODERATE (16 TO 30)";
    } else if (totalDents >= 31 && totalDents <= 50) {
      range = "MEDIUM (31 TO 50)";
    } else if (parts.includes(row.Part) ? totalDents >= 51 && totalDents <= 75 : totalDents >= 51) {
      range = "HEAVY (51 TO 75)";
    } else if (parts.includes(row.Part) && totalDents >= 76 && totalDents <= 100) {
      range = "SEVERE (76 TO 100)";
    } else if (parts.includes(row.Part) && totalDents >= 101 && totalDents <= 150) {
      range = "EXTREME (101 TO 150)";
    } else if (parts.includes(row.Part) && totalDents >= 151 && totalDents <= 200) {
      range = "LIMIT (151 TO 200)";
    } else if (parts.includes(row.Part) && totalDents >= 201) {
      range = "CEILING (201 TO 400)";
    }
  } else if (client == "USAA" || client == "Farmers" || client == "Nationwide") {
      if (totalDents >= 1 && totalDents <= 5) {
      range = "VERY LIGHT (1 TO 5)";
    } else if (totalDents >= 6 && totalDents <= 15) {
      range = "LIGHT (6 TO 15)";
    } else if (totalDents >= 16 && totalDents <= 30) {
      range = "MODERATE (16 TO 30)";
    } else if (totalDents >= 31 && totalDents <= 50) {
      range = "MEDIUM (31 TO 50)";
    } else if (parts.includes(row.Part) ? totalDents >= 51 && totalDents <= 75 : totalDents >= 51) {
      range = "HEAVY (51 TO 75)";
    } else if (parts.includes(row.Part) && totalDents >= 76 && totalDents <= 100) {
      range = "SEVERE (76 TO 100)";
    } else if (parts.includes(row.Part) && totalDents >= 101 && totalDents <= 150) {
      range = "EXTREME (101 TO 150)";
    } else if (parts.includes(row.Part) && totalDents >= 151 && totalDents <= 200) {
      range = "LIMIT (151 TO 200)";
    } else if (parts.includes(row.Part) && totalDents >= 201) {
      range = "CEILING (201 TO 300)";
    }
  } else {
        if (totalDents >= 1 && totalDents <= 5) {
      range = "VERY LIGHT (1 TO 5)";
    } else if (totalDents >= 6 && totalDents <= 15) {
      range = "LIGHT (6 TO 15)";
    } else if (totalDents >= 16 && totalDents <= 30) {
      range = "MODERATE (16 TO 30)";
    } else if (parts.includes(row.Part) ? totalDents >= 31 && totalDents <= 50 : totalDents >= 31) {
      range = "MEDIUM (31 TO 50)";
    } else if (parts.includes(row.Part) && totalDents >= 51 && totalDents <= 75) {
      range = "HEAVY (51 TO 75)";
    } else if (parts.includes(row.Part) && totalDents >= 76 && totalDents <= 100) {
      range = "SEVERE (76 TO 100)";
    } else if (parts.includes(row.Part) && totalDents >= 101 && totalDents <= 150) {
      range = "EXTREME (101 TO 150)";
    } else if (parts.includes(row.Part) && totalDents >= 151 && totalDents <= 200) {
      range = "LIMIT (151 TO 200)";
    } else if (parts.includes(row.Part) && totalDents >= 201) {
      range = "CEILING (201 TO 250)";
    }
  }

    return {
      range,
      type: typeObj[maxValueKey] ? typeObj[maxValueKey] : "",
      maxValueKey: maxValueKey,
    };
  };


  getOriginalPrice = (row, excludeOSPrice) => {
    const { CarTypeArr, data, PricePerHour, client } = this.state;
    let priceJson = USPrice;
    let maxValueForHoodRoofAndTC = 251
    let maxValueForOther = 51
    let OverValueWord = "CR"
      if (client == "USAA") {
      maxValueForHoodRoofAndTC = 301;
      maxValueForOther = 76;
      priceJson = USAAPrice;
      OverValueWord = "CR"
    } else if (client == "Libertymutual") {
      maxValueForHoodRoofAndTC = 401;
      maxValueForOther = 76;
      priceJson = LibertyMutualPrice;
      OverValueWord = "MCE"
    } else if (client == "Nationwide") {
      maxValueForHoodRoofAndTC = 301;
      maxValueForOther = 76;
      priceJson = NationalWidePrice;
      OverValueWord = "CR"
    } else if (client == "Travelers") {
      maxValueForHoodRoofAndTC = 401;
      maxValueForOther = 76;
      priceJson = TravelersPrice;
      OverValueWord = "CR"
    } else if (client == "Farmers") {
      maxValueForHoodRoofAndTC = 301;
      maxValueForOther = 76;
      priceJson = FarmersPrice;
      OverValueWord = "CR"
    } else if (client == "Progressive") {
      maxValueForHoodRoofAndTC = 401;
      maxValueForOther = 76;
      priceJson = ProgressivePrice;
      OverValueWord = "MCE"
    } else{
      maxValueForHoodRoofAndTC = 251;
      maxValueForOther = 51;
      priceJson = USPrice;
      OverValueWord = "CR"
    }
    let [severityClass, part, maxValue, price] = [
      this.getSeverityClass(row, true),
      "",
      "",
      0.0,
    ];
    // maxValue = row[severityClass.maxValueKey];
    maxValue = (row.A + row.B + row.C + row.D + row.E);

    if (["LeftBackFender", "RightBackFender"].includes(row.Part)) {
      part = "backFender";
    } else if (["RightRoofFrame", "LeftRoofFrame"].includes(row.Part)) {
      part = "roofFrame";
    } else if (
      [
        "LeftBackDoor",
        "LeftFrontDoor",
        "RightFrontDoor",
        "RightBackDoor",
        "LeftFrontFender",
        "RightFrontFender",
      ].includes(row.Part)
    ) {
      part = "door";
    } else if (["Metal", "sunroof", "cowl"].includes(row.Part)) {
      part = "other";
    } else {
      part = row.Part;
    }
    priceJson[part] &&
      priceJson[part].length &&
      priceJson[part].map((obj) => {
        if (obj.min <= maxValue && obj.max >= maxValue) {
          price = obj.price[severityClass.type.toLowerCase()];
          if(!obj.price[severityClass.type.toLowerCase()]) {
            price = 0
          }
        // } else if (
        //   ["Hood", "Roof", "TrunkCover"].includes(row.Part) &&
        //   maxValue >= maxValueForHoodRoofAndTC
        // ) {
        //   price =
        //     priceJson[part][priceJson[part].length - 1].price[
        //     severityClass.type.toLowerCase()
        //     ];
        // } else if (
        //   !["Hood", "Roof", "TrunkCover"].includes(row.Part) &&
        //   maxValue >= maxValueForOther
        // ) {
        //   price =
        //     priceJson[part][priceJson[part].length - 1].price[
        //     severityClass.type.toLowerCase()
        //     ];
        }
        return price;
      });

    if(!price) {
      price = (row.E ? row.E * parseInt(PricePerHour) : 0);
      if (row.Part === "Roof" && CarTypeArr.includes(data.CarType)) {
        price = price + price * 0.25;
      }
    } else if(price !== OverValueWord){
      price = excludeOSPrice
        ? price
        : (price ? price : 0) + (row.E ? row.E * parseInt(PricePerHour) : 0);
      if (row.Part === "Roof" && CarTypeArr.includes(data.CarType)) {
        price = price + price * 0.25;
      }
    } else if (excludeOSPrice) {
      price = 0;
    }
    return price;
  };

  getAluGlueAddedPrice = (row) => {
    const { ALUPercentage,client } = this.state;
    let OverValueWord = (client == "Libertymutual" || client == "Progressive") ? "MCE" : "CR"
    let [isCR, originalPrice, aluPr, gluePr, replacePr, incPR, finalPrice] = [
      (this.getOriginalPrice(row) === OverValueWord || (this.getOriginalPrice(row, true) === 0)) ? true : false,
      this.getOriginalPrice(row),
      parseFloat(ALUPercentage),
      parseFloat(glue_percentage),
      parseFloat(replace_percentage),
      0,
      0,
    ];
    if (!row.A && !row.B && !row.C && !row.D && !row.E) {
      return "0.00";
    }
    if (!isCR) {
      if (row.Alu && row.Glue && row.Replace) {
        incPR = aluPr + gluePr + replacePr;
      } else if (row.Alu && row.Glue) {
        incPR = aluPr + gluePr;
      } else if (row.Glue && row.Replace) {
        incPR = gluePr + replacePr;
      } else if (row.Alu) {
        incPR = aluPr;
      } else if (row.Glue) {
        incPR = gluePr;
      } else if (row.Replace) {
        incPR = replacePr;
      } else {
        incPR = 0;
      }

      if (incPR !== 0) {
        finalPrice =
          0 ||
          parseFloat(originalPrice) +
          (parseFloat(this.getOriginalPrice(row, true)) * incPR) / 100.0;
      } else {
        finalPrice = originalPrice;
      }

      row.Push2paint &&
        (finalPrice =
          finalPrice + (row.corrosionProtection ? row.corrosionProtection : 0));

      // return finalPrice.toFixed(2);
      if(finalPrice > 1400) {
        return OverValueWord;
      }else {
        return finalPrice.toFixed(2);
      }
    } else {
      return OverValueWord;
    }
  };

  getGrandTotal = () => {
    const { Dents, client } = this.state;
    let grandTotal = 0;
    let OverValueWord = (client == "Libertymutual" || client == "Progressive") ? "MCE" : "CR"
    grandTotal =
      Dents &&
      Dents.reduce((acc, num) => {
        if (!extraParts.includes(num.Part)) {
          return parseFloat(acc) + parseFloat((this.getAluGlueAddedPrice(num) && this.getAluGlueAddedPrice(num) !== OverValueWord) ? this.getAluGlueAddedPrice(num) : 0);
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return grandTotal.toFixed(2);
  };

  isCRIncludes = () => {
    const { Dents,client } = this.state;
    let OverValueWord = (client == "Libertymutual" || client == "Progressive") ? "MCE" : "CR"
    return Dents && Dents.some((r) => !extraParts.includes(r.Part) && this.getAluGlueAddedPrice(r) === OverValueWord)
  }

  formateDate = (date) => {
    if(!date) {
      return '-';
    }
    let dateArr = date.split('_');
    return `${dateArr[1]}-${dateArr[2]}-${dateArr[0]} ${dateArr[3]}:${dateArr[4]}:${dateArr[5]}`
  }

  getAddress = () => {
    let addressHTML = ''
    this.state.address.split(',').map((r) => {
      addressHTML +=  `${r}<br/>`;
    })
    return addressHTML;
  };

  changeAuthorizeFlag = (authorize, driveType) => {
    this.setState({
      data: {
        ...this.state.data,
        Authorized: authorize,
        DriveThrough: driveType === 'drive_through' ? "0" : driveType === 'drive_in' ? "1" : "",
      },
    });
  }

  render() {
    let partnerId = localStorage.getItem("partnerId");
    // const { Dents } = this.state.data;
    const {orderNo, data, Dents, scannerLocation,customerCompany, color, claimNo,company_name, comment, regNo, manufacturer, model,client, estimateId,kilometerStand, ShowPrice, logo_image,address, primaryContact, email, qrEmail, Name,ALUPercentage, PricePerHour, lang } = this.state;
    let OverValueWord = (client == "Libertymutual" || client == "Progressive") ? "MCE" : "CR"
    const vin = localStorage.getItem("selectedFile");
    let srNo = 0;
    // var order = [
    //   "Hood",
    //   "Roof",
    //   "TrunkCover",
    //   "RightRoofFrame",
    //   "LeftRoofFrame",
    //   "LeftBackFender",
    //   "LeftBackDoor",
    //   "LeftFrontDoor",
    //   "LeftFrontFender",
    //   "RightFrontFender",
    //   "RightFrontDoor",
    //   "RightBackDoor",
    //   "RightBackFender",
    //   // "Trunk",
    // ];
    var order = [
      "Hood",
      "LeftFrontFender",
      "RightFrontFender",
      "Roof",
      "LeftRoofFrame",
      "RightRoofFrame",
      "LeftFrontDoor",
      "RightFrontDoor",
      "LeftBackDoor",
      "RightBackDoor",
      "LeftBackFender",
      "RightBackFender",
      "TrunkCover",
      // "Trunk",
    ];

    Dents.sort(function(a, b) {
      // sort based on the index in order Dents
      return order.indexOf(a.Part) - order.indexOf(b.Part);
    })

    return (
      <>
        <div className="animated fadeIn american_report_main_wrapper">
          {/* <div className="container card_heading_main_bg"> */}
          <div xs="12" sm="12" className="p-2">
            <Card className="print_button_card mt-2">
              <CardHeader>
                <div className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                      <small>
                        {/* {" "}
                            <span>{this.lang("Estimate Id")} :</span>{" "}
                            {orderNo || vin} */}
                        <b>{this.lang("VIN")} </b>: {localStorage.getItem("selectedFile")}
                      </small>
                    </div>
                    <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                        <AmericanReportAuthorization />
                        <ReactToPrint
                          trigger={() => {
                            document.title =
                              vin;
                            return (
                              <button className="btn btn-danger btn-lg pull-right">
                                <i className="fa fa-print" /> Print PDF
                              </button>
                            );
                          }}
                          content={() => this.componentRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
            <div
              className="container american_fullreport_main_wrapper"
              id="divIdToPrintUs"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
            >
              <div className="page_break_main_wrapper">
                <div className="row align-items-center">
                  <div className="col-lg-12 main_column_wrapper">
                    <div className="row align-items-center p-0">
                      <div className="col-lg-6 col-md-6 col-sm-12 pl-0">
                        <div className="american_logo_left_wrapper">
                          <img src={logo_image} alt="cheifLogo" />
                          <h3>{company_name}</h3>
                          <p dangerouslySetInnerHTML={{ __html: this.getAddress(address) }}></p>
                          <p>{primaryContact} <span>{email}</span></p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="american_logo_right_wrapper">
                          <h3>ESTIMATE</h3>
                          <h4 style={{ fontWeight: "400" }}>{estimateId || vin}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Bill Information  */}
                <div className="row align-items-top">
                  <div className="col-lg-12 column_botoom_border">
                    <div className="row align-items-top  pl-0 pr-0">
                      <div className="col-lg-5 col-md-6 col-sm-12 p-0">
                        <div className="american_left_wrapper">
                          <h6>Bill To </h6>
                          <p>{customerCompany || "-"}</p>
                          <p>{Name || '-'}</p>
                          <p>{qrEmail || '-'}</p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="american_center_wrapper">
                          <h6>Owner</h6>
                          <p>NA</p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="american_center_wrapper">
                          <h6>Client</h6>
                          <p>{client || '-'}</p>
                        </div>
                        <div className="american_center_wrapper">
                          <h6>Repair Facility</h6>
                          <p>{company_name || '-'}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-top justify-content-end ">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="american_center_wrapper">
                          {/* <h6>Owner</h6> */}
                          <p>(M) (H/W)</p>
                          <p>NA</p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="american_center_wrapper">
                          <h6>Location</h6>
                          <p>{scannerLocation || '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* VIN Information  */}
                <div className="row align-items-top">
                  <div className="col-lg-12 column_botoom_border">
                    <div className="row align-items-top pl-0 pr-0 ">
                      <div className="col-lg-2 col-md-6 col-sm-12 p-0">
                        <div className="american_left_wrapper">
                          <h6>VIN</h6>
                          {/* <h6>{vin.length === 17 ? 'VIN' : 'Order ID' }</h6> */}
                          <p>{vin}</p>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-3 col-sm-12">
                        <div className="american_center_wrapper">
                          <h6>Vehicle</h6>
                          <p>{manufacturer} - {model}</p>
                          {/* <p>2015 GMC ACADIA DENALI AWD SPORT UTILITY VEHICLE</p> */}
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-3 col-sm-12">
                        <div className="american_center_wrapper">
                          <h6>Car Type</h6>
                          <p>{data.CarType || 'Normal'}</p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="row align-items-top p-0">
                          <div className="col pr-0">
                            <div className="american_center_wrapper">
                              <h6>Stock #</h6>
                              <p>-</p>
                            </div>
                          </div>
                          <div className="col pr-0">
                            <div className="american_center_wrapper">
                              <h6>Color</h6>
                              <p>{color || '-'}</p>
                            </div>
                          </div>
                          <div className="col pr-0">
                            <div className="american_center_wrapper">
                              <h6>License</h6>
                              <p>{regNo || '-'}</p>
                            </div>
                          </div>
                          <div className="col pr-0">
                            <div className="american_center_wrapper">
                              <h6>Mileage</h6>
                              <p>{kilometerStand || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Claim Information  */}
                {/* <div className="row align-items-top">
                <div className="col-lg-12 column_botoom_border">
                  <div className="row align-items-top">
                    <div className="col-lg-3 col-md-4 col-sm-12 mt-2">
                      <div className="american_left_wrapper">
                        <h6>Claim #</h6>
                        <p>{claimNo}</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Deductible</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Deductible Collected</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Date Of Loss</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Invoice #</h6>
                        <p>NA­1439</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Invoice Submitted</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>RO #</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>PO #</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Scheduled For Repair</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Days To Complete</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Check­In</h6>
                        <p>-</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-8 col-sm-12 mt-2">
                      <div className="american_center_wrapper">
                        <h6>Check­Out</h6>
                        <p>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

                {/* Table Information  */}

                <div className="row align-items-top pb-0">
                  <div className="col-lg-12 column_botoom_border main_column_table calculate_table_main" >
                    <div className="table-responsive">
                      <table className="table table-borderless">
                        <thead>
                          <tr>
                            <th>Line</th>
                            <th>-</th>
                            <th>Oper</th>
                            <th className="description_row_head">Description</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>B­Labor</th>
                            <th>P­Labor</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            Dents &&
                            Dents.map((row, i) => {
                              let aluGlueAddedPrice = this.getAluGlueAddedPrice(row);
                              return (
                                !extraParts.includes(row.Part) && (
                                  <Fragment key={i}>
                                    <tr className="part_heading">
                                      <th colSpan={9}>{this.lang(row.Part)}</th>
                                    </tr>
                                    <tr>
                                      <td>{(srNo += 1)}</td>
                                      <td>PE</td>
                                      <td>PDR</td>
                                      <td className="description_row_head">
                                        {this.getDescription(row)}
                                      </td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>
                                        {!ShowPrice ? "-" : aluGlueAddedPrice === OverValueWord ? OverValueWord : (this.getOriginalPrice(row) !== OverValueWord
                                          ? `$${(this.getOriginalPrice(row) - ((row.E || 0) * parseInt(PricePerHour))).toFixed(2)}`
                                          : this.getOriginalPrice(row))}
                                        {/* {!ShowPrice ? "-" : aluGlueAddedPrice === 'CR' ? 'CR' : (this.getOriginalPrice(row) !== "CR"
                                        ? `$${this.getOriginalPrice(row).toFixed(2)}`
                                        : this.getOriginalPrice(row))} */}
                                      </td>
                                      <td>-</td>
                                      <td>
                                        {!ShowPrice ? "-" : this.getAluGlueAddedPrice(row) !== OverValueWord
                                          ? `$${this.getAluGlueAddedPrice(row)}`
                                          : aluGlueAddedPrice === OverValueWord ? OverValueWord : this.getAluGlueAddedPrice(row)}
                                      </td>
                                    </tr>
                                    {row.Alu && (
                                      <tr>
                                        <td>{(srNo += 1)}</td>
                                        <td>PE</td>
                                        <td>PDR</td>
                                        <td>ALU</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>
                                          {ShowPrice ?
                                            `$
                                            ${aluGlueAddedPrice === OverValueWord ? "0.00"
                                              :
                                              ((this.getOriginalPrice(row, true) *
                                                parseFloat(ALUPercentage)) /
                                                100).toFixed(2)
                                            }`
                                            :
                                            "-"
                                          }
                                        </td>
                                        <td>-</td>
                                        <td></td>
                                      </tr>
                                    )}
                                    {row.Glue && (
                                      <tr>
                                        <td>{(srNo += 1)}</td>
                                        <td>PE</td>
                                        <td>PDR</td>
                                        <td>Glue</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>
                                          {ShowPrice ?
                                            `$
                                          ${aluGlueAddedPrice === OverValueWord
                                              ? "0.00"
                                              : (
                                                (this.getOriginalPrice(row, true) * parseFloat(glue_percentage)) /
                                                100
                                              ).toFixed(2)}`
                                            :
                                            "-"
                                          }
                                        </td>
                                        <td>-</td>
                                        <td></td>
                                      </tr>
                                    )}
                                    {row.E != 0 && (
                                      <tr>
                                        <td>{(srNo += 1)}</td>
                                        <td>PE</td>
                                        <td>PDR</td>
                                        <td>OS: {row.E}</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>
                                          {ShowPrice ?

                                            aluGlueAddedPrice === OverValueWord
                                              ? OverValueWord
                                              :
                                              `$${(row.E * parseInt(PricePerHour)).toFixed(2)}`
                                            :
                                            "-"
                                          }
                                        </td>
                                        <td>-</td>
                                        <td>-</td>
                                      </tr>
                                    )}
                                    {row.Push2paint && (
                                      <tr>
                                        <td>{(srNo += 1)}</td>
                                        <td>PE</td>
                                        <td>PE</td>
                                        <td>Paint</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>
                                          {
                                            ShowPrice ?
                                              `$ ${aluGlueAddedPrice === OverValueWord ? "0.00" : row.corrosionProtection}`
                                              :
                                              "-"
                                          }
                                        </td>
                                        <td>-</td>
                                        <td></td>
                                      </tr>
                                    )}
                                    {row.Replace && (
                                      <tr>
                                        <td>{(srNo += 1)}</td>
                                        <td>PE</td>
                                        <td>RI</td>
                                        <td>R & I</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>
                                          {
                                            ShowPrice ?
                                              `$ ${aluGlueAddedPrice === OverValueWord
                                                ? "0.00"
                                                : (
                                                  (this.getOriginalPrice(row, true) * parseFloat(replace_percentage)) /
                                                  100
                                                ).toFixed(2)}`
                                              :
                                              "-"
                                          }

                                        </td>
                                        <td>-</td>
                                        <td></td>
                                      </tr>
                                    )}
                                    {row.arrErsetzen && row.arrErsetzen.length
                                      ? row.arrErsetzen.map((checkbox_val) => {
                                        return (
                                          Array.isArray(row["Ersetzen"]) &&
                                          row["Ersetzen"].includes(checkbox_val) && (
                                            <tr>
                                              <td>{(srNo += 1)}</td>
                                              <td>PE</td>
                                              <td>R</td>
                                              <td>{checkbox_val}</td>
                                              <td>-</td>
                                              <td>-</td>
                                              <td>-</td>
                                              <td></td>
                                              <td></td>
                                            </tr>
                                          )
                                        );
                                      })
                                      : ""}
                                  </Fragment>
                                )
                              )
                            })
                          }



                          {/* <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr className="part_heading">
                          <th colSpan={9}>LEFT FRONT FENDER</th>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>PE</td>
                          <td>PDR</td>
                          <td className="description_row_head">
                            EXCEEDED MATRIX. DIME: 0 NICKEL: 0 QUARTER: 0 HALF
                            DOLLAR: 44
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                          <td>-</td>
                          <td>$3,640.00</td>
                        </tr> */}
                        </tbody>
                      </table>{" "}
                    </div>
                  </div>
                </div>
                <div className="">
                  {/* Note Information  */}
                  <div className="row align-items-top notes_main_wrapper notes_heading pb-0 pt-0">
                    <div className="col-lg-12 column_botoom_border">
                      {/* <div className="row align-items-top">
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="american_left_wrapper">
                          <h6>Note</h6>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="american_left_wrapper">
                          <h6>Created</h6>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="american_left_wrapper">
                          <h6>Created By</h6>
                        </div>
                      </div>
                    </div> */}
                      <div className="table-responsive notes_table_wrapper">
                        <table className="table table-borderless">
                          <thead>
                            <tr>
                              <th>Note</th>
                              <th>Created</th>
                              <th>Created By</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{comment || '-'}</td>
                              <td>
                                {/* {this.formateDate(data.Datetime)} */}
                                {data.Datetime
                                      ? moment(
                                          `${data.Datetime.split("_")[0]}-${
                                            data.Datetime.split("_")[1]
                                          }-${
                                            data.Datetime.split("_")[2]
                                          } ${
                                            data.Datetime.split("_")[3]
                                          }:${
                                            data.Datetime.split("_")[4]
                                          }:${data.Datetime.split("_")[5]}`,
                                          "YYYY-MM-DD HH:mm:ss"
                                        ).format(
                                          localStorage.getItem("client") ==
                                            "US" ||
                                            localStorage.getItem("client") ==
                                              "CANADA"
                                            ? "MM/DD/YYYY / HH:mm:ss"
                                            : "DD.MM.YYYY / HH:mm:ss"
                                        )
                                      : "-"}

                                
                              </td>
                              <td>{partnerId}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-top notes_main_wrapper note_table_main-wrapper pt-0">
                    <div className="col-lg-12 column_botoom_border">
                      <div className="table-responsive">
                        <table className="table table-borderless note_table">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th>Labor Units</th>
                              <th>Labor Rate</th>
                              <th>Cost</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* <tr>
                            <td className="category_name">Paintless Dent Repair</td>
                            <td>-</td>
                            <td>-</td>
                            <td>$5,046.25</td>
                          </tr>
                          <tr>
                            <td className="category_name">Remove And Install</td>
                            <td>2.30</td>
                            <td>$50.00</td>
                            <td>$115.00</td>
                          </tr>
                          <tr>
                            <td className="category_name">Subtotal</td>
                            <td>2.30</td>
                            <td>-</td>
                            <td>$5,161.25</td>
                          </tr>
                          <tr>
                            <td className="category_name">Labor Tax </td>
                            <td>-</td>
                            <td>8.00%</td>
                            <td>$412.90</td>
                          </tr>
                          <tr>
                            <td className="category_name">Deductible</td>
                            <td>-</td>
                            <td>-</td>
                            <td>$0.00</td>
                          </tr> */}
                            <tr>
                              <td className="category_name">Grand Total</td>
                              <td>-</td>
                              <td>-</td>
                              {/* <td>{ShowPrice && `$ ${this.getGrandTotal()}`} {this.isCRIncludes() && ' + CR'}</td> */}
                              <td>
                                {
                                  !ShowPrice ?
                                    "-"
                                    :
                                    <>
                                      {/* {ShowPrice && this.getGrandTotal() !== '0.00' && `$${(this.getGrandTotal() && this.isCRIncludes() ) ? this.getGrandTotal() + ' + ' : this.getGrandTotal()}`} {this.isCRIncludes() && 'CR'} */}
                                      {ShowPrice && `$${(this.getGrandTotal() && this.isCRIncludes()) ? this.getGrandTotal() + ' + ' : this.getGrandTotal()}`} {this.isCRIncludes() && OverValueWord}
                                    </>
                                }
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AmericanReportFull;
